import Vue from 'vue'
import App from './App.vue'
import { initEnv } from '@bilibili/js-bridge'

Vue.config.productionTip = false

initEnv()

new Vue({
  render: h => h(App),
}).$mount('#app')
